export { Modal } from './Modal.js';
//# sourceMappingURL=index.js.map
